import { useState, useEffect, createContext } from "react";
import { db, auth, functions } from "../firebase";
export const UserValue = createContext();

export default function UserContext({ children }) {
  const [authUser, setAuthUser] = useState(null);
  const [user, setUser] = useState(null);
  const [userToken, setUserToken] = useState(null);
  const createJwt = functions.httpsCallable("createJwt");

  function getJwt() {
    return createJwt()
      .then(jwt => {
        setUserToken(jwt.data);
        return jwt.data;
      })
      .catch(() => false);
  }

  useEffect(() => {
    let unsub = auth.onAuthStateChanged((u) => {
      setAuthUser(u);
    });
    return unsub;
  }, []);

  useEffect(() => {
    let unsub;
    if (authUser) {
      unsub = () => setUserToken(authUser.jwt);
    }
    else {
      setUserToken(null);
    }
    return unsub;
  }, [authUser]);

  useEffect(() => {
    let unsub;
    if (authUser) {
      unsub = db
        .collection("users")
        .doc(authUser.uid)
        .onSnapshot((doc) => {
          setUser({ ...doc.data(), id: doc.id });
        });
    } else {
      setUser(null);
    }
    return unsub;
  }, [authUser]);

  useEffect(() => {
    if (!userToken && authUser) {
      getJwt();
    }
  }, [userToken, authUser]);

  return <UserValue.Provider value={{...user, jwt: userToken, refreshToken: getJwt}}>{children}</UserValue.Provider>;
}
